// Keeps the Belomgeving working state (lead, side tab, script position, unsaved notes) for this browser tab,
// so employees can visit other CRM pages during a call and return exactly where they left off.
const KEY = "fe-bel-session";

export const readBel = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const writeBel = (patch) => sessionStorage.setItem(KEY, JSON.stringify({ ...readBel(), ...patch }));
export const readBelFor = (part, leadId) => (readBel()[part] || {})[leadId];
export const writeBelFor = (part, leadId, value) => {
  const cur = readBel()[part] || {};
  if (value === undefined) delete cur[leadId]; else cur[leadId] = value;
  writeBel({ [part]: cur });
};
